import { mixinGoPage, mixinGoBack } from '@/utils'
export default {
  methods: {
    /**
     * 跳转页面方法封装 （兼容mixin）
     * @param routeUrl 路由页面路径
     */
    mixinGoPage,

    /**
     * 页面返回方法封装 （兼容mixin）
     * @param step 回退层级，-1代表回退上一层
     */
    mixinGoBack,
  },
}
